import { Skeleton } from "@material-ui/lab";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { RiFileCopyLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import useHelperFunctions from "../../../../componentsV2/helperFunctions";

import { getInitials } from "../../SettingsSidebar";
import styles from "./referrals.module.css";
import { LightTooltip } from "../../../../componentsV2/atoms/Tooltip/tooltip";

const Referrals = ({ userEmail = "" }) => {
    const [isCopied, setIsCopied] = useState(false);
    const [referCode, setReferCode] = useState("");
    const [referrals, setReferrals] = useState([]);
    const { getData } = useHelperFunctions();
    const [isLoading, setIsLoading] = useState(false);

    const currency = useSelector((state) => state.auth.currency);

    useEffect(() => {
        apiCall();
    }, []);

    const apiCall = async () => {
        setIsLoading(true);
        const res = await getData({ url: "/api/refer/get" });
        if (res.status == 200) {
            console.log("refer", res.data);
            setReferCode(res.data?.refer_code);
            // shift self to top start
            let temp = res.data?.referrals ? res.data?.referrals : [];
            if (temp?.length) {
                let tempObj = temp.splice(
                    temp.findIndex((obj) => obj?.referee_email == "self"),
                    1,
                );
                if (tempObj.length) {
                    temp.unshift(tempObj[0]);
                    setReferrals(temp);
                }
            }
            // shift self to top end
        } else {
            console.log("refer", res);
        }
        setIsLoading(false);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setIsCopied(true);
    };

    const SELF = "self";

    return (
        <div className={styles.referralContainer}>
            <div className={styles.containerTop}>
                <div className={styles.container__left}>Referral Benefits</div>
                <div className={styles.container__right}>
                    <div className={styles.referCodeTile}>
                        Unique Referral Code:{" "}
                    </div>
                    <div className={styles.referCode}>
                        {referCode?.length ? referCode : "****************"}
                        <span>
                            <LightTooltip
                                title={!isCopied ? "Copy" : "Copied!"}
                                placement={"top"}
                                arrow
                            >
                                <span
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => copyToClipboard(referCode)}
                                >
                                    <RiFileCopyLine color={"#6b6b6b"} />
                                </span>
                            </LightTooltip>
                        </span>
                    </div>
                </div>
            </div>
            {/* Table starts */}
            <div className={styles.tableParent}>
                <table style={{ width: "100%" }}>
                    <tr className={styles.tableHeading}>
                        <th
                            style={{
                                textAlign: "left",
                                paddingLeft: "64px",
                                borderBottom: "1px solid #f1f1f1",
                            }}
                        >
                            Email ID of Referee
                        </th>
                        <th
                            style={{
                                textAlign: "center",
                                width: "300px",
                                borderBottom: "1px solid #f1f1f1",
                            }}
                        >
                            Date of Purchase
                        </th>
                        <th
                            style={{
                                textAlign: "center",
                                borderBottom: "1px solid #f1f1f1",
                            }}
                        >
                            Credits Earned
                        </th>
                    </tr>
                    {isLoading ? (
                        <>
                            {/* Dummy Row starts */}
                            <tr className={styles.memberRow}>
                                <td
                                    style={{
                                        textAlign: "left",
                                        paddingLeft: "64px",
                                    }}
                                >
                                    {" "}
                                    <Skeleton width={100}></Skeleton>{" "}
                                </td>
                                <td
                                    style={{
                                        textAlign: "center",
                                        width: "340px",
                                    }}
                                >
                                    <Skeleton width={120}></Skeleton>
                                </td>
                                <td style={{ paddingLeft: "10px" }}>
                                    <Skeleton width={80}></Skeleton>
                                </td>
                            </tr>
                            {/* Dummy Row ends */}
                        </>
                    ) : (
                        <>
                            {referrals?.length ? (
                                referrals.map((referral, i) => {
                                    return (
                                        <tr
                                            key={referral + "" + i}
                                            className={
                                                styles.memberRow +
                                                " " +
                                                (referral?.referee_email == SELF
                                                    ? styles.self
                                                    : "")
                                            }
                                        >
                                            <td style={{ paddingLeft: "10px" }}>
                                                <div className={styles.nameCol}>
                                                    <div
                                                        className={
                                                            styles.tMemberAvatar
                                                        }
                                                    >
                                                        {getInitials(
                                                            referral?.referee_email?.toLowerCase() ==
                                                                SELF
                                                                ? userEmail
                                                                : referral?.referee_email,
                                                        )}
                                                    </div>
                                                    {referral?.referee_email.toLowerCase() ==
                                                    SELF
                                                        ? userEmail
                                                        : referral?.referee_email}
                                                </div>
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                {referral?.subscription_at
                                                    ? moment(
                                                          referral?.subscription_at,
                                                      ).format("DD 	MMM, 	YYYY")
                                                    : "--"}
                                            </td>

                                            {referral?.referee_email == SELF ? (
                                                <td
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {referral?.referee_credits
                                                        ? currency == "INR"
                                                            ? "₹ " +
                                                              referral?.referee_credits
                                                            : "$ " +
                                                              referral?.referee_credits
                                                        : "--"}
                                                </td>
                                            ) : (
                                                <td
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {referral?.referrer_credits
                                                        ? currency == "INR"
                                                            ? "₹ " +
                                                              referral?.referrer_credits
                                                            : "$ " +
                                                              referral?.referrer_credits
                                                        : "--"}
                                                </td>
                                            )}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr
                                    style={{
                                        width: "100",
                                        textAlign: "center",
                                        marginTop: "40px",
                                    }}
                                >
                                    <td colSpan={3}>
                                        <p>No Referrals Found</p>
                                    </td>
                                </tr>
                            )}
                        </>
                    )}
                </table>
            </div>
            {/* Table ends */}
        </div>
    );
};

export default Referrals;
